/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  TextInput as MantineInput,
  TextInputProps as MantineTextInputProps,
} from "@mantine/core";
import { FieldRenderProps } from "react-final-form";
import { GenericInputSearch } from "../../models/generic";
import { InputWrapper } from "./styles";
import { DisabledColor, colors } from "../../styles/colors";
import { FC, ChangeEvent } from "react";
import { Block } from "../../styles/basicStyles";
import Icon from "../icon";

export interface TextInputProps extends Omit<FieldRenderProps<string>, "input">, MantineTextInputProps {
  afterChange?: (value: string) => void;
  onSearch?: (value: string) => void;
  input: GenericInputSearch<any>;
  clearable?: boolean;
}

export const SearchInput: FC<TextInputProps> = ({
  input,
  meta = {},
  label,
  placeholder,
  description,
  afterChange,
  variant,
  clearable = false,
  onSearch,
  ...rest
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    input.onChange(event.currentTarget.value);
    if (afterChange && typeof afterChange === "function") {
      afterChange(event.currentTarget.value);
    }
  };

  const handleClear = () => {
    input.onChange("");
    if (afterChange && typeof afterChange === "function") {
      afterChange("");
    }
  };

  const hasError = meta?.invalid && meta?.submitFailed;

  const showClear = clearable && input.value && input.value !== "" && (
    <Icon
      onClick={handleClear}
      icon="bold_xCircle"
      color={DisabledColor}
      size={1.25}
      style={{ cursor: "pointer" }}
    />
  );

  const handleEnter = (e: any) => {
    if (onSearch && e.key === "Enter") {
      onSearch(input.value || "");
    }
  };

  return (
    <InputWrapper search hasError={hasError}>
      <MantineInput
        {...rest}
        type="text"
        label={label}
        placeholder={placeholder}
        description={description}
        variant={variant}
        rightSection={showClear}
        value={input.value}
        onChange={handleChange}
        onKeyDown={handleEnter}
        icon={
          <Block ml={1.25}>
            <Icon icon="outlined_search" color={colors.coolGrey} size={1.375} />
          </Block>
        }
      />
    </InputWrapper>
  );
};

export default SearchInput;
